export default {
  sceneAttribute: 'Scene Attributes',
  endingScene: 'Ending Scene',
  sceneDesc:
    'Please set one end scene for your playable in order to calculate the completion rate',
  warnEnding: 'Keep at least one ending scene',
  viewSetting: {
    single: 'Single scene view',
    story: 'Storyboard view',
    global: 'Global scene view',
    play: 'Gameplay scene view',
  },
  playScene: {
    title: 'Gameplay Template',
    back: 'Back to Project',
    create: 'Create gameplay template',
    none: 'No gameplay templates are used in the current material',
    errorMsg:
      'Paste content includes NO supportive of file types and sound effects on the current scene',
    action: {
      edit: 'Edit gameplay',
      bind: 'Bind scene',
      unbind: 'Unbind scene',
      quick: 'Quick layout',
      back: 'Back to creative',
      delete: 'Delete',
      componentSetting: 'Click here to access component settings.',
    },
    unbind: 'Unbind',
    need: 'Bind success',
    bindNote: 'Unbind success',
    unbindNote: 'No quick layout added',
  },
  otherLayer: 'Others',
  globalScene: {
    edit: 'Go to Editor',
    title: 'Global scene',
    settingTips: {
      title:
        'Global settings can set the background image, background color, background music, multi-language, and can also design a global scene to apply to all scenes.',
      name: 'The global scene can add images, text, sound effects, animation effects, etc. You can change the design of all scenes by changing the content in the global scene.',
    },
    isGlobal: {
      checkboxLabel: 'Enable',
    },
    globalIndex: {
      top: 'Put on top',
      bottom: 'Put on the bottom',
    },
  },
}
